import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable react/no-unknown-property */
const Rectangle = ({ fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55" className="Common__SideNav__Container__object__img">
        <rect width="55" height="55" x="27" y="197" fill={fill} fillRule="evenodd" transform="translate(-27 -197)" />
    </svg>
);
/* eslint-enable react/no-unknown-property */

Rectangle.propTypes = {
    fill: PropTypes.string
};

Rectangle.defaultProps = {
    fill: ''
};

export default Rectangle;
